












































import Vue from "vue";
import bcrypt from "bcryptjs";
import USER_PASSWORD_UPDATE from "@/graphql/users/UserPasswordUpdate.gql";

export default Vue.extend({
  name: "PasswordDialog",
  props: {
    userId: String,
    open: Boolean
  },
  data: () => ({
    form: { firstPassword: "", secondPassword: "" },
    valid: false,
    showPassword: false,
    passwordRules: [(v: string) => !!v || "Bitte Passwort eingeben"]
  }),
  methods: {
    save(): void {
      if (!(this.$refs.form as any).validate()) return;
      this.$apollo
        .mutate({
          mutation: USER_PASSWORD_UPDATE,
          variables: {
            id: this.userId,
            password: bcrypt.hashSync(this.form.secondPassword, 8)
          }
        })
        .then(() => {
          this.close();
        });
    },
    close(): void {
      this.form.firstPassword = "";
      this.form.secondPassword = "";
      this.$emit("close");
    }
  },
  mounted() {
    const compare = (v: string) =>
      v === this.form.firstPassword ||
      "Wiederholung entspricht nicht der ersten Eingabe";
    this.passwordRules.push(compare as any);
  }
});
